import React, { createContext, useState, useContext } from 'react';
import { FullPageLoader } from '../components/Loader';

const LoaderContext = createContext([
  false,
  (value) => {}
]);

export const LoaderProvider = ({ children }) => {
  const loadingState = useState(false);
  const [loading] = loadingState;

  return (
    <LoaderContext.Provider value={loadingState}>
      {children}
      {loading && <FullPageLoader />}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  const loaderState = useContext(LoaderContext);
  return loaderState;
};

export const withLoader = (Comp) => () => (
  <LoaderProvider>
    <Comp />
  </LoaderProvider>
);

export default LoaderContext;
